export enum EnvironmentType {
    DEV = "DEV",
    PRE = "PRE",
}
